import { getAboutMonthlyPass } from "../../../app/api/getCmsAboutMonthlyPass";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsAboutMonthlyPass } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsAboutMonthlyPassAction extends BaseAction<ICmsAboutMonthlyPass | null, void> {
  override async run(): Promise<ICmsAboutMonthlyPass | null> {
    let result: ICmsAboutMonthlyPass | null = null;
    try {
      const response = await getAboutMonthlyPass();

      if (response.status === "ok" && response.answer) {
        result = response?.answer?.data;
      } else {
        console.warn("Failed to fetch about monthly pass.");
      }
    } catch (error: any) {
      console.error("Error fetching about monthly pass:", error);
    } finally {
      updateRecoilState("cmsAboutPassDetailAtom", result);
      return result;
    }
  }
}

export const getCmsAboutMonthlyPassAction = new GetCmsAboutMonthlyPassAction();
